import { useState, useEffect } from 'react';

/**
 * Reactive dark-mode hook — responds to runtime theme switches.
 * Watches body.classList for the 'dark' class via MutationObserver.
 */
export function useIsDark(): boolean {
  const [isDark, setIsDark] = useState(() =>
    document.body.classList.contains('dark'),
  );

  useEffect(() => {
    const observer = new MutationObserver(() => {
      setIsDark(document.body.classList.contains('dark'));
    });
    observer.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    return () => observer.disconnect();
  }, []);

  return isDark;
}
